import styled from 'styled-components';

export const ButtonStyle = styled.button`
  display: flex;
  border: none;
  color: var(--color-white);
  background: ${(props) =>
    `${props.color} 0% 0% no-repeat` ||
    'var(--color-blue-primary) 0% 0% no-repeat'};
  margin: ${(props) => props.margin || '0px'};
  border-radius: 5px;
  padding: ${(props) => props.padding || '13px 17px'};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font: normal normal 600 14px/20px Source Sans Pro;
  cursor: pointer;
`;

export const ButtonStyleOutline = styled.button`
  display: flex;
  border: 1px solid ${(props) => props.color || 'var(--color-white)'};
  color: ${(props) => props.color || 'var(--color-white)'};
  background-color: var(--color-white);
  margin: ${(props) => props.margin || '0px'};
  border-radius: 5px;
  padding: ${(props) => props.padding || '13px 17px'};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font: normal normal 600 14px/20px Source Sans Pro;
  cursor: pointer;
`;
